<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgaccount.automations' | trans }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="card">
                <div class="card-body">
                    <app-projectautomation [automationType]="'orgautomation'" ></app-projectautomation>
                </div>
            </div>
        </div>
    </div>
</div>